import { useForm } from "react-hook-form";
import { Button, Input } from "../ui";
import { RxReload } from "react-icons/rx";
import useBasicLogin from "../../hooks/auth/useBasicLogin";
import useSetPassword from "../../hooks/auth/useSetPassword";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const SetPassword = () => {
  const [searchParams] = useSearchParams();
  const emailFromUrl = searchParams.get("email") || "";
  const inviteCode = searchParams.get("invite_code") || "";
  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      email: emailFromUrl,
      password: "",
      confirm_password: "",
      code: inviteCode,
    },
  });
  const { handleSetPassword, setPassword } = useSetPassword();
  const password = watch("password");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  return (
    <div className="w-[69.5%] space-y-4">
      <Input
        control={control}
        disabled
        label={"Email"}
        name={"email"}
        placeholder={"Please Enter Email"}
        rules={{
          required: "Email is required",
        }}
      />
      <div className="relative">
        <Input
          control={control}
          label={"Password"}
          type={showPassword ? "text" : "password"}
          name={"password"}
          placeholder={"Please Enter Password"}
          rules={{
            required: "Password is required",
          }}
        />
        <Button
          type="button"
          className={"absolute right-3 top-[50%] transform  text-gray-500"}
          variant={"ghost"}
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <AiOutlineEyeInvisible className="w-5 h-5" />
          ) : (
            <AiOutlineEye className="w-5 h-5" />
          )}
        </Button>
      </div>

      <div className="relative">
        <Input
          control={control}
          label={"Confirm Password"}
          type={showConfirmPassword ? "text" : "password"}
          name={"confirm_password"}
          placeholder={"Please Confirm Password"}
          rules={{
            required: "Confirm Password is required",
            validate: (value) => value === password || "Passwords do not match",
          }}
        />
        <Button
          type="button"
          variant={"ghost"}
          size={"icon"}
          className={"absolute right-3 top-[50%] transform  text-gray-500"}
          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
        >
          {showConfirmPassword ? (
            <AiOutlineEyeInvisible className="w-5 h-5" />
          ) : (
            <AiOutlineEye className="w-5 h-5" />
          )}
        </Button>
      </div>
      <Button
        onClick={handleSubmit(handleSetPassword)}
        disabled={setPassword.isLoading}
      >
        <span className="mr-2">Set Password</span>
        {setPassword.isLoading && <RxReload className=" animate-spin" />}
      </Button>
    </div>
  );
};

export default SetPassword;
